import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

/**
 * Container
 * Main container for validation box
 * Always uses neutral styling - individual items show validation status
 */
export const Container = superstyled({
  name: 'PasswordValidationBox',
  slot: 'Container',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[200]}`,
    transition: 'all 0.3s ease'
  })
});

/**
 * Title
 * Title text for validation box
 */
export const Title = superstyled({
  name: 'PasswordValidationBox',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1.5),
    display: 'block'
  })
});

/**
 * ValidationList
 * Container for validation items
 */
export const ValidationList = superstyled({
  name: 'PasswordValidationBox',
  slot: 'ValidationList',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  })
});

/**
 * ValidationItem
 * Individual validation requirement item
 */
export const ValidationItem = superstyled({
  name: 'PasswordValidationBox',
  slot: 'ValidationItem',
  tag: Box,
  propsNeeded: ['hasPassed'],
  styles: ({ theme, hasPassed }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: hasPassed ? theme.palette.success.main : theme.palette.text.secondary,
    transition: 'color 0.3s ease'
  })
});

/**
 * IconWrapper
 * Wrapper for validation icon
 */
export const IconWrapper = superstyled({
  name: 'PasswordValidationBox',
  slot: 'IconWrapper',
  tag: Box,
  propsNeeded: ['hasPassed'],
  styles: ({ theme, hasPassed }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: hasPassed ? theme.palette.success.main : theme.palette.grey[400],
    transition: 'color 0.3s ease',
    '& svg': {
      fontSize: '1.2rem'
    }
  })
});

/**
 * ValidationText
 * Text for validation requirement
 */
export const ValidationText = superstyled({
  name: 'PasswordValidationBox',
  slot: 'ValidationText',
  tag: Text,
  styles: () => ({
    lineHeight: 1.4
  })
});
